export default {
    label_login:{
        en:"Login",
        bn:"প্রবেশ করুন"
    },
    label_clear_login:{
        en:"Retry Login",
        bn:"পুনরায় চেষ্টা করুন"
    },
    label_please_login:{
        en:"Welcome, please login to your account.",
        bn:"স্বাগতম, আপনার অ্যাকাউন্টে লগইন করুন।"
    },
    label_username:{
        en:"Username",
        bn:"ইউজার নেম"
    },
    label_password:{
        en:"Password",
        bn:"পাসওয়ার্ড"
    },
    label_otp:{
        en:"OTP",
        bn:"ওটিপি"
    },
    label_verify_otp:{
        en:"An OTP sent to your mobile.</br>Please verify you otp",
        bn:"আপনার মোবাইলে একটি ওটিপি পাঠানো হয়েছে৷</br>দয়া করে আপনার ওটিপি যাচাই করুন৷"
    },
    //api response
    INVALID_CREDENTIALS:{
        en:'Your password is Incorrect.',
        bn:'আপনার পাসওয়ার্ডটি সঠিক নয়।'
    },
    USER_INACTIVE:{
        en:'This user is In-Active.',
        bn:'এই ইউজার নিষ্ক্রিয় আছে।'
    },
    USER_NOT_FOUND:{
        en:'This user Not Found.',
        bn:'এই ইউজার পাওয়া যায়নি।'
    },
    OTP_MISMATCHED:{
        en:'OTP did not matched.',
        bn:'ওটিপি মেলেনি।'
    },
    OTP_EXPIRED:{
        en:'Your has been OTP Expired.',
        bn:'আপনার ওটিপির মেয়াদ শেষ হয়ে গেছে।'
    },
    OTP_USED:{
        en:'Your OTP has been used.',
        bn:'আপনার ওটিপি ব্যবহার করা হয়েছে।'
    },
    OTP_INVALID:{
        en:'Your OTP is invalid.',
        bn:'আপনার ওটিপি সঠিক নয়।'
    },
    'The username field is required.':{
        en:"The username field is required.",
        bn:"ইউজার নেম অবশ্যক"
    },
    'The password field is required.':{
        en:"The password field is required.",
        bn:"পাসওয়ার্ড অবশ্যক"
    },
}